/**
 * FormSection — `.form-section` from the prototype (cms-redesign-mockup.html
 * ~2894–2918). The surface card every edit form is built on.
 *
 *   <FormSection title="Basic info" num="01">
 *     <FieldBlock label="Title" required>
 *       <TextInput value={...} onChange={...} />
 *     </FieldBlock>
 *     …
 *   </FormSection>
 *
 * Visual recipe:
 *   • Surface bg, sand border, rounded-lg, padding 24/28
 *   • H2: Asap Condensed 16/700 navy with a 3px teal accent bar
 *     before it and a JetBrains-Mono `num` chip pushed to the right
 *   • Optional `right` slot for inline chips (e.g. "Duplicated session")
 */
import React from 'react';
import { cn } from '../cn';

export default function FormSection({
  title,
  num,
  right,
  className,
  children,
}) {
  return (
    <section
      className={cn('bg-surface border border-sand', className)}
      style={{
        borderRadius: 12,
        padding: '24px 28px',
        marginBottom: 16,
      }}
    >
      <h2
        className="font-condensed font-bold text-navy"
        style={{
          fontSize: 16,
          letterSpacing: '-0.01em',
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          margin: '0 0 16px',
        }}
      >
        <span
          aria-hidden
          style={{
            display: 'inline-block',
            width: 3,
            height: 16,
            background: 'rgb(var(--color-teal-green))', /* teal-green */
            borderRadius: 4,
          }}
        />
        <span style={{ minWidth: 0 }}>{title}</span>
        {right && (
          <span style={{ marginLeft: 8, display: 'inline-flex' }}>{right}</span>
        )}
        {num && (
          <span
            className="font-mono text-text-muted bg-cream"
            style={{
              fontSize: 11,
              fontWeight: 500,
              padding: '2px 7px',
              borderRadius: 999,
              marginLeft: 'auto',
            }}
          >
            {num}
          </span>
        )}
      </h2>
      {children}
    </section>
  );
}
